import { render, staticRenderFns } from "./ComponentsTree.vue?vue&type=template&id=082925a5"
import script from "./ComponentsTree.vue?vue&type=script&lang=js"
export * from "./ComponentsTree.vue?vue&type=script&lang=js"
import style0 from "./ComponentsTree.vue?vue&type=style&index=0&id=082925a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports